<template>
  <div>
    <div v-if="$page.props.auth.user.owner && showModal">

      <div class="bg-white rounded-md shadow overflow-hidden max-w-6xl">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="weight" class="pr-6 pb-8 w-full lg:w-1/2" label="Weight (kg)" type="number" step="0.5" required />
            <text-input v-model="noofpacks" class="pr-6 pb-8 w-full lg:w-1/2" label="No Of Packages" type="number" step="1" required />
            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
              <button class="btn-indigo" style="margin:5px; background: grey;" v-on:click="updateModel(false, false)" type="button">{{__('Cancel')}} </button>
              <button class="btn-indigo" type="button" v-on:click="updateModel(true, true)" >{{__('Save')}}</button>
            </div>
        </div>
      </div>
  
    </div>
    <div v-if="!showModal">
      <h1 class="mb-8 font-bold text-3xl">{{__('Orders')}}</h1>
      <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
          <!-- <label class="block text-gray-700">Trashed:</label>
          <select v-model="form.trashed" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="with">With Trashed</option>
            <option value="only">Only Trashed</option>
          </select> -->
        </search-filter>
        <inertia-link class="btn-indigo" :href="route('orders.create')" v-if="(!$page.props.auth.user.owner) && $page.props.auth.user.customer_id == 0">
          <!-- <span>{{__('Create')}}</span> -->
          <span class="hidden md:inline">{{__('Order')}}</span>
        </inertia-link>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">{{__('Order')}} No</th>
            <th class="px-6 pt-6 pb-4" v-if="$page.props.auth.user.owner || $page.props.auth.user.customer_id != 0">{{__('Bakery Name')}}</th>
            <th class="px-6 pt-6 pb-4">{{__('Contact')}}</th>
            <th class="px-6 pt-6 pb-4">{{__('Email')}}</th>
            <!-- <th class="px-6 pt-6 pb-4">{{__('Label')}}</th> -->
            <th class="px-6 pt-6 pb-4">{{__('Quantity')}}</th>
            <th class="px-6 pt-6 pb-4">{{__('Status')}}</th>
            <!-- <th class="px-6 pt-6 pb-4">{{__('Delivery Date')}}</th> -->
            <th class="px-6 pt-6 pb-4">{{__('Detail')}}</th>
          </tr>
          <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t p-4">
                <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1">
                    {{order.contact.ref_no}}-{{ order.order_no }}
                  </inertia-link>
              </td>
              <td class="border-t p-4" v-if="$page.props.auth.user.owner || $page.props.auth.user.customer_id != 0">
                  <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1">
                    {{ order.contact.business_name }}
                  </inertia-link>
              </td>
              <td class="border-t">
                  <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1">
                    {{ order.contact.name }}
                  </inertia-link>
              </td>
              <td class="border-t">
                  <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1">
                    {{ order.contact.email }}
                  </inertia-link>
              </td>
              <!-- <td class="border-t">
                  {{ order.label.label_name}}
              </td> -->
              <td class="border-t pl-1per">
                  <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1">
                    {{getBoxes(order.quantity)}}
                  </inertia-link>
              </td>
              <td class="border-t pl-1per">

                <button :class="[order.status == 'Shipped'?'btn-success':'btn-indigo']" v-on:click="updateStatus(order.id, order.status)" tabindex="-1" v-if="$page.props.auth.user.owner && (order.status == 'Paid' || order.status == 'Shipped')">
                    {{ __(order.status) }}
                </button>

                  <!-- <inertia-link :class="[order.status == 'Shipped'?'btn-success':'btn-indigo']" :href="route('order.toggleStatus', order.id)" tabindex="-1" v-if="$page.props.auth.user.owner && (order.status == 'Paid' || order.status == 'Shipped')">
                    {{ __(order.status) }}
                  </inertia-link> -->

                  <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1" v-else>
                    {{ __(order.status) }}
                  </inertia-link>

              </td>
                <!-- <td class="border-t pl-2per">
                  <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1">
                    {{ order.delivery_date }}
                  </inertia-link>
              </td> -->
              <td class="border-t w-px">
                <inertia-link class="px-4 flex items-center" :href="route('order.show', order.id)" tabindex="-1">
                  <icon name="view" class="block w-6 h-6 fill-indigo-400" />
                </inertia-link>
                <icon name="" class="block w-6 h-6 fill-black-400"/>
                <inertia-link class="px-4 flex items-center" :href="route('order.cencel', order.id)" tabindex="-1" v-if="$page.props.auth.user.owner && order.status == 'Pending'">
                  <icon name="cross" class="block w-6 h-6 fill-red-400" />
                </inertia-link>
              </td>
            <!-- <td class="border-t w-px">
                <a class="btn-indigo csvbtn" target="_blank" :href="route('orders.csv', order.id)" v-if="$page.props.auth.user.owner">
                  <span class="hidden md:inline">CSV</span>
                </a>
                <button v-if="$page.props.auth.user.owner" class="btn-indigo" tabindex="-1" type="button" @click="csv(order.id)"> Create CSV</button>
            </td> -->
            <td class="border-t w-px" v-if="$page.props.auth.user.owner || order.status == 'Paid'">
                <a class="btn-indigo csvbtn" target="_blank" :href="route('orders.invoice', order.id)">
                  <span class="hidden md:inline">{{__("Invoice")}}</span>
                </a>
            </td>
            <!-- <td class="border-t w-px" v-if="$page.props.auth.user.owner">
                <a class="btn-indigo csvbtn" :href="route('orders.emailInvoice', order.id)">
                  <span class="hidden md:inline">{{__("Send")}} {{__("Invoice")}} </span>
                </a>
            </td> -->
            <!-- <td class="border-t w-px" v-if="order.status == 'Pending'">
                <a class="btn-indigo csvbtn" :href="route('orders.paynoworder', order.id)">
                  <span class="hidden md:inline">Pay Now</span>
                </a>
            </td> -->
          </tr>
          <tr v-if="orders.data.length === 0">
            <td class="border-t px-6 py-4" colspan="4">{{__('No orders found.')}}</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="orders.links" />
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'


export default {
  metaInfo: { title: 'Orders' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    TextInput,
    LoadingButton
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      weight: null,
      noofpacks: null,
      showModal : false,
      orderId : null,
      status : null
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('orders'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
    model: {
      // 
    }
  },
  mounted(){
    // console.log(this.orders)
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    getBoxes(quantity){
      if(quantity == 1){
        return '1 Item'
      }else{
        return quantity+' Items'
      }
    },
    csv(orderId){
      this.$inertia.get(this.route('orders.csv', orderId))
    },
    updateStatus(order, status){

      // remove below line to make next code block work.
      // this.$inertia.get(this.route('order.toggleStatus', order))
      
      if(status == 'Paid'){
        // show dialog to ask for weight and nopack
        this.orderId = order
        this.status = status
        this.updateModel(true, false)
      }else{
        this.$inertia.get(this.route('order.toggleStatus', order))
      }

      // if (confirm('Are you sure you want to delete this Label?')) {
        // this.$inertia.delete(this.route('labels.destroy', label_id))
      // }

      // window.location.href = 'order/toggleStatus'+'?'+status;
      // Inertia.visit(route('order.toggleStatus', status),{ 
      //         onBefore: () => confirm('Are you sure?'), 
      //   })

      // :href="route('order.toggleStatus', order.id,weight,nopack)"
    },
    updateModel(val, save){
      
      if(save){
        if(this.weight == null || this.noofpacks == null){
          alert("Please Enter weight and No Of Packages.")
        }else{
          if(this.weight != null && this.noofpacks != null && this.orderId != null && this.status != null){
            // this.weight = 1
            // this.noofpacks = 1

            let data = {
                      status: this.status,
                      orderId: this.orderId, 
                      weight: this.weight, 
                      noofpacks: this.noofpacks
                    }
            // alert(data)
            this.showModal = false
            this.$inertia.post(this.route('order.toggleStatusShipping', data))
          }
        }
      }else{
        // alert('in update Model save : '+save)
        this.showModal = val
      }
      
      return save
    }
  },
}
</script>
<style scoped>
.pl-2per{
  padding-left: 2%;
}
.csvbtn{
  padding: 0.25rem 1rem 0.25rem 1rem;
  margin-right: 1rem;
}
.modal-body {
    min-width: 300px;
}

input:invalid {
    border-color: red;
}

body {
    margin-bottom: 24pt;
}

.btn-space {
    margin-right: 5px !important;
}
</style>